'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  PENDING_WALLET_ADDRESS: 'Pending Wallet Address',
  PENDING_TRANSACTION_RECEIPT: 'Pending Transaction Receipt',
  PENDING_PAYMENT_VERIFICATION: 'Pending Payment Verification',
  INVESTMENT_COMPLETE: 'Investment Complete'
});